import React from 'react';
import { useParams } from 'react-router-dom';
import { ClientRouteGuard } from '@/components/layouts/RecordRouteGuard/ClientRouteGuard';
import { Box } from '@mui/material';
import ClientViewWrapper from '@/components/views/ClientView/ClientViewWrapper';

const ViewClientPage = () => {
	const { clientId } = useParams();

	// Keyed so switching clients (e.g. via global search) remounts the view instead of showing the old client's data.
	return (
		<ClientRouteGuard>
			<Box pb={3}>
				<ClientViewWrapper key={clientId} />
			</Box>
		</ClientRouteGuard>
	);
};

export default ViewClientPage;
